<template>
  <app-auth-title />

  <div class="auth-content">
    <!-- Table -->
    <div class="table-card">
      <div class="table-header">
        <div>
          <h3>Uploaded Schedule Files</h3>
          <p>Previously uploaded schedule templates.</p>
        </div>

        <div class="table-search">
          <input type="text" placeholder="Search filename..." />
        </div>
      </div>

      <table class="schedule-table">
        <thead>
          <tr>
            <th width="60">#</th>
            <th>Filename</th>
            <th>Sheet Name</th>
            <th width="140">Action</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="(item, index) in uploads" :key="index">
            <td>{{ index + 1 }}</td>

            <td>
              <div class="file-info">
                <i class="fa fa-file-excel-o"></i>

                {{ item.filename }}
              </div>
            </td>

            <td>
              <span class="sheet-tag">
                {{ item.sheetname }}
              </span>
            </td>

            <td>
              <button class="btn-view" @click="viewSchedule(item)">
                <i class="fa fa-eye"></i>
                Download
              </button>
            </td>
          </tr>

          <tr v-if="uploads.length === 0">
            <td colspan="6" class="empty-row">
              <i class="fa fa-folder-open-o"></i>
              <br />
              No uploaded schedule found.
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Instructions -->
    <div class="instruction-card">
      <h3>Instructions</h3>

      <ul>
        <li>Download the official Excel template.</li>
        <li>Do not modify the column headers.</li>
        <li>Employee names must match the system.</li>
        <li>Use one worksheet per schedule.</li>
        <li>Uploading the same filename and sheet name automatically archives the previous upload.</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BulkUploadShiftingSchedule',

  data() {
    return {
      uploads: [
        {
          filename: 'August Schedule.xlsx',
          sheetname: 'Week 31',
          start_date: '2026-08-03',
          end_date: '2026-08-09',
          total_records: 140,
        },
        {
          filename: 'August Schedule.xlsx',
          sheetname: 'Week 32',
          start_date: '2026-08-10',
          end_date: '2026-08-16',
          total_records: 140,
        },
      ],
    };
  },

  methods: {
    viewSchedule(item) {
      console.log(item);
    },
  },
};
</script>

<style scoped>
.auth-content {
  padding: 35px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.08);
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 35px;
}

.header h1 {
  color: var(--lightSecondary);
  font-family: 'Montserrat';
  margin-bottom: 5px;
}

.header p {
  color: #666;
  font-family: 'Montserrat';
  font-size: 14px;
}

.btn-template {
  border: none;
  background: var(--lightSecondary);
  color: white;
  padding: 12px 18px;
  border-radius: 6px;
  cursor: pointer;
}

.upload-card {
  border: 2px dashed #d9d9d9;
  border-radius: 10px;
  padding: 40px;
  text-align: center;
}

.upload-icon {
  font-size: 70px;
  color: #1d6f42;
}

.upload-description {
  margin: 15px 0;
  color: #777;
}

.btn-select,
.btn-upload {
  border: none;
  padding: 12px 25px;
  border-radius: 6px;
  cursor: pointer;
  margin: 5px;
}

.btn-select {
  background: #efefef;
}

.btn-upload {
  background: #28a745;
  color: white;
}

.table-card {
  margin-top: 40px;
}

.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.table-header h3 {
  color: var(--lightSecondary);
  margin: 0;
}

.table-header p {
  margin-top: 5px;
  color: #777;
}

.table-search input {
  width: 250px;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 6px;
}

.schedule-table {
  width: 100%;
  border-collapse: collapse;
  font-family: 'Montserrat';
}

.schedule-table thead {
  background: #f6f6f6;
}

.schedule-table th,
.schedule-table td {
  padding: 15px;
  border-bottom: 1px solid #ececec;
  text-align: left;
}

.schedule-table tbody tr:hover {
  background: #fafafa;
}

.file-info {
  display: flex;
  gap: 10px;
  align-items: center;
}

.file-info i {
  color: #1d6f42;
}

.sheet-tag {
  background: #eef4ff;
  color: #2356a8;
  padding: 5px 10px;
  border-radius: 20px;
  font-size: 13px;
}

.badge {
  background: #e8f5e9;
  color: #2e7d32;
  padding: 5px 12px;
  border-radius: 20px;
}

.btn-view {
  border: none;
  background: var(--lightSecondary);
  color: white;
  padding: 8px 15px;
  border-radius: 5px;
  cursor: pointer;
}

.empty-row {
  text-align: center;
  color: #888;
  padding: 40px;
}

.instruction-card {
  margin-top: 40px;
  background: #fafafa;
  border-left: 5px solid var(--lightSecondary);
  padding: 20px;
  border-radius: 8px;
}

.instruction-card h3 {
  margin-top: 0;
}

.instruction-card li {
  margin-bottom: 8px;
}
</style>
